import { UserSearchPage } from "../../features/users";

export function AdminUsersPage() {
  return <UserSearchPage />;
}
